import React from 'react';
import { FaPhone, FaEnvelope, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
	const { t } = useTranslation();
	return (
		<div>
			<footer className='bg-section'>
				<div className='container  grid grid-cols-1 md:grid-cols-2 '>
					<div className='contacat flex flex-col gap-4 my-12 '>
						<h3 className='text-main text-2xl font-semibold mb-4'>
							{t('contactUs')}
						</h3>
						{/* دخ مكان العنوان */}
						<div className='flex gap-2 items-center'>
							<FaEnvelope className='text-secondary w-3 h-3' />
							<p className='text-textColor text-md'>schema.aiot@gmail.com </p>
						</div>
						<div className='flex gap-2 items-center'>
							<FaPhone className='text-secondary w-3 h-3 rotate-90' />
							<p className='text-textColor text-md'>+20 11 50020781</p>
						</div>
					</div>

					<div className='Course  my-12'>
						<h3 className='text-main text-2xl font-semibold  mb-4'>
							{t('courses')}
						</h3>
						<ul className='flex flex-col gap-2 list-square list-inside'>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('university')}
								</NavLink>
							</li>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('brandingDesign')}
								</NavLink>
							</li>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('uiuxDesigning')}
								</NavLink>
							</li>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('makeElements')}
								</NavLink>
							</li>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('business')}
								</NavLink>
							</li>
							<li className='[&::marker]:text-secondary'>
								<NavLink className='text-textColor md:hover:text-secondary transform-all duration-500'>
									{t('graphicsDesign')}
								</NavLink>
							</li>
						</ul>
					</div>
				</div>

				<div className='socialMedia border-t-2 border-solid border-[#ccd5df]'>
					<div className='container py-2 flex flex-col md:flex-row justify-between md:items-center gap-4'>
						<div className='footerContainer flex items-center w-2/4 md:w-auto'>
							<div className='image w-20 ml-[-10px]'>
								<img
									loading='lazy'
									src={'/images/Logo.png'}
									alt='mlogo of company'
									className='object-cover'></img>
							</div>
							<NavLink
								to='/'
								className='font-bold  text-main'>
								{t('companyName')}
							</NavLink>
						</div>
						<p className='text-textColor'>{t('copyright')}</p>

						<div className='links flex gap-3'>
							{[
								{
									icon: FaFacebook,
									href: 'https://www.facebook.com/share/18zard5pW3/',
								},
								{ icon: FaWhatsapp, href: 'https://wa.me/qr/MJTCYGYOGITOJ1' },
								{ icon: FaEnvelope, href: 'mailto:schema.aiot@gmail.com' },
							].map((item, index) => (
								<a
									key={index}
									href={item.href}
									target='_blank'
									rel='noreferrer'
									className='flex justify-center items-center rounded-full w-10 h-10 p-2 text-[#ccd5df] text-lg border-[1px] border-[#ccd5df] border-solid md:hover:text-main md:hover:bg-secondary md:hover:border-secondary transform-all duration-500'>
									<item.icon />
								</a>
							))}
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
};

export default Footer;
